import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

function extractText(value) {
  if (value === null || value === undefined) {
    return "";
  }
  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }
  if (Array.isArray(value)) {
    return value.map(extractText).join(", ");
  }
  // React element
  if (value && value.$$typeof) {
    var props = value.props || {};
    // Try children first
    if (props.children !== undefined && props.children !== null) {
      return extractText(props.children);
    }
    // For NumberFormat and similar: try value prop
    if (props.value !== undefined && props.value !== null) {
      return extractText(props.value);
    }
    return "";
  }
  // Object with props
  if (value && value.props) {
    if (value.props.children !== undefined) {
      return extractText(value.props.children);
    }
    if (value.props.value !== undefined) {
      return extractText(value.props.value);
    }
    return "";
  }
  // Plain object
  if (typeof value === "object") {
    return JSON.stringify(value);
  }
  return String(value);
}

export var generateXlsx = function (columns, data, title, fileName) {
  var workbook = new ExcelJS.Workbook();
  workbook.creator = "Bongah";
  workbook.created = new Date();

  var sheet = workbook.addWorksheet(title, {
    views: [{ rightToLeft: true }],
  });

  var filteredColumns = columns.filter(function (col) {
    return col.title !== "#";
  });

  // Add row number column at the beginning
  var headerRow = sheet.addRow(
    ["#"].concat(
      filteredColumns.map(function (col) {
        return col.title;
      })
    )
  );

  // Style header row
  headerRow.eachCell(function (cell) {
    cell.font = {
      name: "Vazir",
      size: 12,
      bold: true,
      color: { argb: "FFFFFFFF" },
    };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF01579B" },
    };
    cell.alignment = {
      horizontal: "center",
      vertical: "middle",
      wrapText: true,
    };
    cell.border = {
      top: { style: "thin", color: { argb: "FFCCCCCC" } },
      left: { style: "thin", color: { argb: "FFCCCCCC" } },
      bottom: { style: "thin", color: { argb: "FFCCCCCC" } },
      right: { style: "thin", color: { argb: "FFCCCCCC" } },
    };
  });

  headerRow.height = 30;

  // Data rows
  data.forEach(function (rowData) {
    var values = [rowData.id || ""].concat(
      filteredColumns.map(function (col) {
        // Prefer pdfRender for plain text output
        if (typeof col.pdfRender === "function") {
          return extractText(col.pdfRender(rowData));
        }
        if (typeof col.render === "function") {
          return extractText(col.render(rowData));
        }
        return extractText(rowData[col.field]);
      })
    );

    var row = sheet.addRow(values);

    row.eachCell(function (cell) {
      cell.font = {
        name: "Vazir",
        size: 11,
      };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };
      cell.border = {
        top: { style: "thin", color: { argb: "FFCCCCCC" } },
        left: { style: "thin", color: { argb: "FFCCCCCC" } },
        bottom: { style: "thin", color: { argb: "FFCCCCCC" } },
        right: { style: "thin", color: { argb: "FFCCCCCC" } },
      };
    });

    row.height = 25;
  });

  // Auto-fit columns
  sheet.columns.forEach(function (column) {
    var maxLength = 0;
    column.eachCell({ includeEmpty: false }, function (cell) {
      var val = cell.value;
      var length = 0;
      if (typeof val === "string" || typeof val === "number") {
        length = String(val).length;
      }
      if (length > maxLength) {
        maxLength = length;
      }
    });
    column.width = Math.max(maxLength + 2, 15);
  });

  // Generate and download
  workbook.xlsx.writeBuffer().then(function (buffer) {
    var blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, fileName || "export.xlsx");
  });
};

export default generateXlsx;
